import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../use.store';
import SearchPoiCard from './SearchPoiCard';
import Pagination from './Pagination';

const SearchSuggestionPois = observer(({ poi, onClickPoi }) => {
    const { mainStore } = useStores();
    const [page, setPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(4);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 768px)'); // md

        const handleChange = (e) => {
            setItemsPerPage(e.matches ? 6 : 4);
            setPage(1);
        };

        handleChange(mediaQuery);
        mediaQuery.addEventListener('change', handleChange);

        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    const pois = mainStore.pois || [];
    const totalPages = Math.ceil(pois.length / itemsPerPage);

    const currentPois = useMemo(() => {
        const start = (page - 1) * itemsPerPage;
        return pois.slice(start, start + itemsPerPage);
    }, [pois, page]);

    const handleNext = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    const handlePrev = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };
    return (
        <div>
            <div className="grid grid-cols-2 md:grid-cols-3 grid-rows-2 gap-3 md:gap-6">
                {currentPois.map((poi) => (
                    <SearchPoiCard
                        key={poi.id}
                        poi={poi}
                        onClick={() => onClickPoi(poi)}
                    />
                ))}
            </div>

            {totalPages > 1 && (
                <div className="flex justify-center mt-4 sm:mt-8 md:mb-6 md:mt-10">
                    <Pagination
                        currentPage={page}
                        setPage={setPage}
                        totalPages={totalPages}
                        handlePrev={handlePrev}
                        handleNext={handleNext}
                    />
                </div>
            )}
        </div>
    );
});

export default SearchSuggestionPois;
